module.exports = __webpack_public_path__ + "step2_parent_to_child.544b4c2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step2_parent_to_child.jpg
// module id = 0WEr
// module chunks = 0